import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange, bookings }) => {
  // Extract unique service types from bookings
  const serviceTypes = [...new Set(bookings?.map(b => b?.serviceInterest)?.filter(Boolean))];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'pending', label: 'Pending' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'upcoming', label: 'Upcoming' },
    { value: 'past', label: 'Past' },
    { value: 'this_month', label: 'This Month' }
  ];

  const serviceTypeOptions = [
    { value: 'all', label: 'All Services' },
    ...serviceTypes?.map(service => ({
      value: service,
      label: service
    }))
  ];

  return (
    <div className="bg-white rounded-xl shadow-elevation-1 p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={20} className="text-primary" />
        <h2 className="text-lg font-semibold text-foreground">Filters & Search</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Status Filter */}
        <Select
          label="Status"
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
          options={statusOptions}
        />

        {/* Date Range Filter */}
        <Select
          label="Date Range"
          value={filters?.dateRange}
          onChange={(value) => onFilterChange('dateRange', value)}
          options={dateRangeOptions}
        />

        {/* Service Type Filter */}
        <Select
          label="Service Type"
          value={filters?.serviceType}
          onChange={(value) => onFilterChange('serviceType', value)}
          options={serviceTypeOptions}
        />

        {/* Search */}
        <div>
          <label className="text-sm font-medium text-foreground mb-2 block">
            Search
          </label>
          <div className="relative">
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
            />
            <Input
              type="text"
              placeholder="Client, email, company..."
              value={filters?.searchTerm}
              onChange={(e) => onFilterChange('searchTerm', e?.target?.value)}
              className="pl-10"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;